import type { SVGProps } from 'react';

const SvgMobileFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path
      d='M16 1.25C17.5188 1.25 18.75 2.48122 18.75 4V20C18.75 21.5188 17.5188 22.75 16 22.75H8C6.48122 22.75 5.25 21.5188 5.25 20V4C5.25 2.48122 6.48122 1.25 8 1.25H16ZM12 19C11.4477 19 11 19.4477 11 20C11 20.5523 11.4477 21 12 21C12.5523 21 13 20.5523 13 20C13 19.4477 12.5523 19 12 19ZM6.75 5V18H17.25V5H6.75Z'
      fill='currentColor'
    />
  </svg>
);
export default SvgMobileFilled;
